import * as React from 'react';
import { ClientSignSession } from './useClientSignSession';

export const useClientSignOrderedFields = (session: ClientSignSession) => {
	const { detectedFields, fields } = session;

	const orderedFields = React.useMemo(
		() =>
			[...detectedFields]
				.filter((field) => !fields[field.id]?.readOnly)
				.sort((a, b) => {
					if (a.pageIndex !== b.pageIndex) return a.pageIndex - b.pageIndex;
					return b.rect.y - a.rect.y;
				}),
		[detectedFields, fields]
	);

	const completedFieldCount = React.useMemo(
		() =>
			orderedFields.filter((field) => {
				const value = fields[field.id]?.value;
				if (typeof value === 'boolean') return value;
				return Boolean(value?.trim());
			}).length,
		[orderedFields, fields]
	);

	return { orderedFields, completedFieldCount };
};
